import { ReactTFC } from "../../../utils/fp/missing-ts-parts";
import React from "react";

import { css } from "@emotion/react";
import { CSS_COLORS } from "../../../styles/styles-css-variables";
import { ContentContainer } from "../../../components/_shared-components/arrangement/Container";
import { CSS_MQ } from "../../../styles/breakpoints";
import { FONTS, fontSize } from "../../../styles/fonts";

export const StoryLayoutHeadlineLarge: ReactTFC<{
  seoHeadline: string;
  emoHeadline: string;
  alignment: "Left" | "Center" | "Right";
}> = props => {
  const textAlignStyles = css`
    text-align: ${props.alignment.toLowerCase()};
  `;

  return (
    <ContentContainer>
      <h1
        css={[
          FONTS.SwarovskiFutura500,
          fontSize.x2,
          textAlignStyles,
          css`
            text-transform: uppercase;

            color: ${CSS_COLORS.Black};

            margin-top: 0;
            margin-bottom: 10px;
          `,
        ]}
      >
        {props.seoHeadline}
      </h1>
      <h2
        css={[
          FONTS.MinervaModern500,
          css`
            text-transform: uppercase;
            margin: 0;
            color: ${CSS_COLORS.Green};

            font-size: 24px;
            letter-spacing: 0.4px;
            line-height: 26px;

            ${CSS_MQ.atLeastMd} {
              font-size: 48px;
              letter-spacing: 2.4px;
              line-height: 48px;
            }

            ${textAlignStyles};
          `,
        ]}
      >
        {props.emoHeadline}
      </h2>
    </ContentContainer>
  );
};
